import _regeneratorRuntime from "/home/ubuntu/Local-Stitch-Front/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/ubuntu/Local-Stitch-Front/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import MemberShipIntroService from 'components/membership/_index';
import { GetMembershipServiceAPI } from 'api/service';
import { serviceActions } from 'store/service';
import { ERROR_500 } from 'constants/message';
import { useRouter } from 'next/router';

var MemberShip = function MemberShip(_ref) {
  var error = _ref.error;
  var router = useRouter();
  useEffect(function () {
    if (error) {
      alert(ERROR_500);
      router.push('/');
    }
  }, []);
  return /*#__PURE__*/_jsx(MemberShipIntroService, {});
};

MemberShip.getInitialProps = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
    var store, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            store = _ref2.store;
            _context.next = 3;
            return GetMembershipServiceAPI();

          case 3:
            response = _context.sent;

            if (!(response.status >= 400)) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", {
              error: true
            });

          case 6:
            store.dispatch(serviceActions.setMembershipService(response.data.results));
            return _context.abrupt("return", {
              error: false
            });

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref3.apply(this, arguments);
  };
}();

export default MemberShip;